document.querySelectorAll('.header-filter').forEach((wrap) => {
  const { body } = document;
  const openButton = wrap.querySelector('.header-filter__open');
  const closeButton = wrap.querySelector('.header-filter__close');
  const panel = wrap.querySelector('.header-filter__filter');

  // Open filter
  const openFilter = (event) => {
    body.classList.add('body--filter-expanded');
    event.stopPropagation();
    return false;
  };
  openButton.addEventListener('click', openFilter);

  // Close filter
  const closeFilter = () => {
    body.classList.remove('body--filter-expanded');
  };
  closeButton.addEventListener('click', closeFilter);

  // Click outside filter
  const clickOutsideFilter = (event) => {
    const isClickInside = panel.contains(event.target);
    if (!isClickInside) {
      body.classList.remove('body--filter-expanded');
    }
  };
  document.addEventListener('click', clickOutsideFilter);
});
